import { styled } from '@mui/material/styles';
import { Mui } from '@onedesign/ui';

const { Box, Typography } = Mui;

export const BannerContainerStyles = styled(Box)(() => ({
  display: 'flex',
  width: '100%',
  padding: '13px 12px 13px 16px',
  alignItems: 'center',
  gap: '12px',
  alignSelf: 'stretch',
  border: '1px solid #FFE16A',
  background: '#FFF7CD',
  justifyContent: 'space-between',
}));

export const WrapperLeftWarningStyles = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '12px',
}));

export const ImgWarningStyles = styled('img')(() => ({
  width: '24px',
  height: '24px',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',

  '&:hover': {
    transform: 'scale(1.1)',
  },

  '&:active': {
    transform: 'scale(0.9)',
  },
}));

export const TextBannerStyles = styled(Typography)(() => ({
  fontFamily: 'Noto Sans TC',
  fontSize: '14px',
  fontWeight: '400',
  lineHeight: '22px',
  fontStyle: 'normal',
  color: '#7A400B',
  flex: '1 0 0',
  marginLeft: '5px',
}));
